// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDocumentSummaryMutationVariables = Types.Exact<{
  documentID: Types.Scalars['ID']['input'];
  input: Types.CreateDocumentSummaryInput;
}>;


export type CreateDocumentSummaryMutation = { __typename?: 'Mutation', createDocumentSummary: { __typename?: 'DocumentSummary', id: string } };

export const Operations = {
  Mutation: {
    CreateDocumentSummary: 'CreateDocumentSummary' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateDocumentSummaryDocument = gql`
    mutation CreateDocumentSummary($documentID: ID!, $input: CreateDocumentSummaryInput!) {
  createDocumentSummary(documentID: $documentID, input: $input) {
    id
  }
}
    `;
export type CreateDocumentSummaryMutationFn = Apollo.MutationFunction<CreateDocumentSummaryMutation, CreateDocumentSummaryMutationVariables>;

/**
 * __useCreateDocumentSummaryMutation__
 *
 * To run a mutation, you first call `useCreateDocumentSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentSummaryMutation, { data, loading, error }] = useCreateDocumentSummaryMutation({
 *   variables: {
 *      documentID: // value for 'documentID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentSummaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentSummaryMutation, CreateDocumentSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentSummaryMutation, CreateDocumentSummaryMutationVariables>(CreateDocumentSummaryDocument, options);
      }
export type CreateDocumentSummaryMutationHookResult = ReturnType<typeof useCreateDocumentSummaryMutation>;
export type CreateDocumentSummaryMutationResult = Apollo.MutationResult<CreateDocumentSummaryMutation>;
export type CreateDocumentSummaryMutationOptions = Apollo.BaseMutationOptions<CreateDocumentSummaryMutation, CreateDocumentSummaryMutationVariables>;